<div class="login-box">
  <div class="login-logo">
    <app-logo [hide]='"mini"'></app-logo>

  </div>
  <h3 style="text-align: center;">{{ translate.instant('PAGES.passwordChange') }}</h3>

  <h5>{{ translate.instant('PAGES.welcomeDocsIa') }}</h5>
  <!-- /.login-logo -->
  <div class="login-box-body">
    <p class="login-box-msg">{{ translate.instant('PAGES.enterNewPassword') }}</p>

    <form [formGroup]="formChangePassword">

      <div class="form-group">
        <label for="password" class="visually-hidden">{{ translate.instant('LOGIN.password') }}</label>
        <app-password-input id="password" name="password" [placeholder]="translate.instant('PAGES.password')" autocomplete="new-password"
          formControlName="password"></app-password-input>
        <div
          *ngIf="formChangePassword.controls.password.errors && (formChangePassword.controls.password.dirty || formChangePassword.controls.password.touched)"
          class="alert alert-danger" role="alert">
          <div [hidden]="!formChangePassword.controls.password.errors.required">
            {{ translate.instant('PAGES.passwordRequired') }}
          </div>
          <div [hidden]="!formChangePassword.controls.password.errors.passwordStrength">
            {{ translate.instant('PAGES.thePasswordMustContain') }}
          </div>
        </div>
        <app-password-strength-checklist [flags]="passwordFlags"></app-password-strength-checklist>
      </div>

      <div class="form-group">
        <label for="passwordConfirm" class="visually-hidden">{{ translate.instant('PAGES.confirmPasswordPlaceholder') }}</label>
        <app-password-input id="passwordConfirm" name="passwordConfirm" [placeholder]="translate.instant('PAGES.confirmPasswordPlaceholder')"
          autocomplete="new-password" formControlName="passwordConfirm"></app-password-input>
        <div *ngIf="!isEqualPassword " class="alert alert-danger" role="alert">
          <div>
            {{ translate.instant('PAGES.thePasswordAreDifferent') }}
          </div>
        </div>
      </div>


      <div class="row">

        <!-- /.col -->
        <div class="col-4">
          <button type="submit" [disabled]="!formChangePassword.valid || !isEqualPassword"
            class="btn btn-primary btn-block btn-flat" (click)="saveChange()">{{ translate.instant('PAGES.change')
            }}</button>
        </div>
        <!-- /.col -->
      </div>

    </form>
  </div>

</div>